import { render, staticRenderFns } from "./WholeCalendarSearchInput.vue?vue&type=template&id=0aaafbe8&scoped=true"
import script from "./WholeCalendarSearchInput.vue?vue&type=script&lang=js"
export * from "./WholeCalendarSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaafbe8",
  null
  
)

export default component.exports